export default __webpack_public_path__ + "static/media/wideImgHero.25b8a2bc.jpg";